import router from "@/router";

const moment = require("moment");
moment.locale("fr");

function getCurrentTime() {
  return moment().set({ year: 1970, month: 0, date: 1 });
}

function getCurrentTimeNow(year?: string, month?: string, day?: string) {
  let m = moment();
  if (year)
    m.set('year', Number.parseInt(year));
  if (month)
    m.set('month', Number.parseInt(month) - 1);
  if (day)
    m.set('date', Number.parseInt(day));
  return m;
}

function getAnneDiff(oldDate: any, currentDate: any) {
  let y = currentDate.diff(oldDate, 'years');
  let m = currentDate.diff(oldDate, 'months');
  return y === 0 ? m + ' mois' : y + ' ans';
}
function getDateFromString(str: string, format?: string) {
  if (format) {
    return moment(str, format)
  } else {
    return moment(str, "DD/MM/YYYY HH:mm")
  }
}
function isSameDate(date1: any, date2: any, option?: string) {
  if (option) {
    return date1.isSame(date2, option)
  } else {
    return date1.isSame(date2)
  }
}
function getDateWithAdding(nbr: number, negatif?: boolean) {
  const current = utils.getCurrentTimeNow();
  if (typeof negatif !== 'undefined' && negatif) {
    return current.add(-nbr, 'weeks').format('YYYY-MM-DD')
  } else {
    return current.add(nbr, 'weeks').format('YYYY-MM-DD')
  }
}

function GetFileExtensionFromBase64(base64: string) {
  if (typeof base64 === 'undefined')
    return -1
  let extension: string = "-1"
  switch (base64.charAt(0)) {
    case '/':
      extension = "jpg"
      break;
    case 'i':
      extension = "png"
      break;
    case 'R':
      extension = "gif"
      break;
    case 'U':
      extension = "webp"
      break;
  }
  return extension
}
function decimalToHexString(number: number) {
  let hex: string = number.toString(16).toUpperCase();
  while (hex.length < 6) {
    hex = "0" + hex;
  }

  return "#" + hex;
}

function getFingerprint() {
  return btoa(navigator.platform + navigator.vendor + navigator.userAgent);
}
// must match your replication options

function getProgress(pending: number) {
  let progress;
  let pendingMax = 0;
  let batch_size = 100;
  pendingMax = pendingMax < pending ? pending + batch_size : pendingMax;
  if (pendingMax > 0) {
    progress = 1 - pending / pendingMax;
    if (pending === 0) {
      pendingMax = 0;    // reset for live/next replication
    }
  } else {
    progress = 1;  // 100%
  }
  return progress;
}

function paginate(array: Array<any>, page_size: number, page_number: number): Array<any> {
  // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
  return Array.from(array.slice((page_number - 1) * page_size, page_number * page_size));
}
function calculateMaxPage(array: Array<any>, page_size: number): number {
  return Math.ceil(
    array.length /
    page_size
  );
}
function iconActivite(id: number) {
  let ICON: any = {};
  ICON[
    "ICON_1"
  ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_AUTOMNE.svg`);
  ICON[
    "ICON_2"
  ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_NOEL.svg`);
  ICON[
    "ICON_3"
  ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_HIVER.svg`);
  ICON[
    "ICON_4"
  ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_PRINTEMPS.svg`);
  ICON[
    "ICON_5"
  ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_ETE.svg`);
  ICON[
    "ICON_6"
  ] = require(`@/assets/activite/icons-types/ALSH_SEJOUR_MERCREDI.svg`);
  ICON["ICON_7"] = require(`@/assets/activite/icons-types/ATELIERS.svg`);
  ICON[
    "ICON_8"
  ] = require(`@/assets/activite/icons-types/PERISCOLAIRE.svg`);
  ICON[
    "ICON_9"
  ] = require(`@/assets/activite/icons-types/RESTAURATION.svg`);
  ICON[
    "ICON_DEFAULT"
  ] = require(`@/assets/activite/icons-types/default.png`);

  switch (id) {
    case -1:
      return ICON["ICON_1"];
    case -2:
      return ICON["ICON_2"];
    case -3:
      return ICON["ICON_3"];
    case -4:
      return ICON["ICON_4"];
    case -5:
      return ICON["ICON_5"];
    case -6:
      return ICON["ICON_6"];
    case -7:
      return ICON["ICON_7"];
    case -8:
      return ICON["ICON_7"];
    case -9:
      return ICON["ICON_8"];
    case -10:
      return ICON["ICON_8"];
    case -11:
      return ICON["ICON_9"];
    case -12:
      return ICON["ICON_1"];
    case -13:
      return ICON["ICON_2"];
    case -14:
      return ICON["ICON_3"];
    case -15:
      return ICON["ICON_4"];
    case -16:
      return ICON["ICON_5"];
    case -17:
      return ICON["ICON_1"];
    case -18:
      return ICON["ICON_2"];
    case -19:
      return ICON["ICON_3"];
    case -20:
      return ICON["ICON_4"];
    case -21:
      return ICON["ICON_5"];
    case -22:
      return ICON["ICON_6"];
    default:
      return ICON["ICON_DEFAULT"];
  }
}
function getImgFromIntitule(regim: string): any {
  if (regim === "Autre")
    return require(`@/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg`);
  else if (regim === "Sans porc")
    return require(`@/assets/information/regime/REG_ALIM_SANS_PORC.svg`);
  else if (regim === "Sans viande")
    return require(`@/assets/information/regime/REG_ALIM_SANS_VIANDE.svg`);
  else if (regim === "Végétarien")
    return require(`@/assets/information/regime/REG_ALIM_VEGETARIEN.svg`);
  else if (regim === "Sans gluten")
    return require(`@/assets/information/regime/REG_ALIM_SANS_GLUTEN.svg`);
  else if (regim === "PAI")
    return require(`@/assets/information/regime/REG_ALIM_PAI.svg`);
  else if (regim === "Sans régime")
    return require(`@/assets/information/regime/REG_ALIM_DEFAUT_STANDARD.svg`);
  else if (regim === "Sans poisson")
    return require(`@/assets/information/regime/REG_ALIM_SANS_POISSON.svg`);
  else
    return require(`@/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg`);
}
function getSrcIndividu(base64: string) {
  if (typeof base64 === 'undefined' || base64.length === 0)
    return require(`@/assets/information/SILHOUETTE_FICHE_INDIV_DEFAUT.svg`);
  let extension = utils.GetFileExtensionFromBase64(base64);
  if (extension === "-1")
    return require(`@/assets/information/SILHOUETTE_FICHE_INDIV_DEFAUT.svg`);
  else return `data:image/${extension};base64,${base64}`;
}
function getSrcEtablissement(base64: string) {
  if (typeof base64 === 'undefined' || base64.length === 0)
    return require(`@/assets/inoe-logo/Logo_iNoe.svg`);
  let extension = utils.GetFileExtensionFromBase64(base64);
  if (extension === "-1")
    return require(`@/assets/inoe-logo/Logo_iNoe.svg`);
  else return `data:image/${extension};base64,${base64}`;
}
class AutoRedirect {
  callStartId: any = undefined;
  callPauseId: number | undefined = undefined;
  redirectTimeout: number = 0;
  path: string = "";
  constructor(path: string) {
    this.path = path;
  }
  redirect() {
    console.log("redirect to" + this.path);
    router.push(this.path);
  }
  start(redirectTimeout: number) {
    this.redirectTimeout = redirectTimeout;
    let me = this;
    this.callStartId = setTimeout(function () {
      me.redirect();
    }, this.redirectTimeout);
  }
  resume() {
    this.stop();
    console.log("redirect Timeout: " + this.redirectTimeout);
    this.start(this.redirectTimeout);
  }
  stop(): boolean {
    let result = false;
    if (typeof this.callPauseId !== "undefined") {
      console.log("clear callPauseId:" + this.callPauseId);
      clearTimeout(this.callPauseId);
      // result = true;
    }
    if (typeof this.callStartId !== "undefined") {
      console.log("clear callStartId:" + this.callStartId);
      clearTimeout(this.callStartId);
      result = true;
    }
    this.callPauseId = undefined;
    this.callStartId = undefined;
    return result;
  }
  pause() {
    console.log("pause called");
    let me = this;
    if (this.stop()) {
      console.log("will call resum in 2s");
      setTimeout(function () {
        me.resume();
      }, 2000);
    }
  }
  changepath(path: string) {
    this.path = path
  }
}
let ar = new AutoRedirect("/home");

const DEFAULTUSERPHOTO = "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";
export const utils = {
  getCurrentTime,
  getCurrentTimeNow,
  getDateFromString,
  ar,
  getAnneDiff,
  isSameDate,
  GetFileExtensionFromBase64,
  decimalToHexString,
  DEFAULTUSERPHOTO,
  getDateWithAdding,
  getFingerprint,
  getProgress,
  paginate,
  calculateMaxPage,
  iconActivite,
  getImgFromIntitule,
  getSrcIndividu,
  getSrcEtablissement
};